import { render } from "./App.vue?vue&type=template&id=3cf668b4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3cf668b4&lang=css"

import exportComponent from "/home/sts/Documents/BrianN/project/ONELINE/vue-app-template/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__